import { TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { useTheme } from '@mui/material/styles';

const CohortStatsTableHead = (props) => {
    const { columns } = props;
    const theme = useTheme();
    const tableCells = columns?.map((column, idx) => (
        <TableCell
            key={column?.fieldKey}
            sx={{
                backgroundColor: "#424242",
                color: `${theme?.custom?.white} !important`,
                whiteSpace: "nowrap",

                ".Mui-active": {
                    color: `${theme?.custom?.white} !important`,
                    ".MuiTableSortLabel-icon": {
                        color: `${theme?.custom?.white} !important`,
                    },
                },
                ".MuiTableSortLabel-root": {
                    color: `${theme?.custom?.white} !important`,
                    ":hover": {
                        color: `${theme?.custom?.white} !important`,

                        ".MuiTableSortLabel-icon": {
                            color: `${theme?.custom?.white} !important`,
                        },
                    },
                },
            }}
            sortDirection={column?.sort?.direction}
            align={idx === 0 ? "left" : "center"}
            onClick={() => {
                column?.sort?.method(column?.fieldKey);
            }}
        >
            {column?.sortable ? (
                <TableSortLabel
                    active={column?.sort?.active}
                    direction={column?.sort?.direction}
                    onClick={column?.sort?.method}
                >
                    {column?.name}
                </TableSortLabel>
            ) : (
                column?.name
            )}
        </TableCell>
    ));

    return (
        <TableHead>
            <TableRow>{tableCells}</TableRow>
        </TableHead>
    );
};

export default CohortStatsTableHead;
